import React, { FC, useMemo } from "react";
import StatusDialog, { StatusDialogProps } from "../../Unknown/StatusDialog";
import Typography from "../../Unknown/Typography";
import useTranslations from "./useTranslations";

export type AppointmentMarkNoShowDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  handleSubmit: () => void | Promise<void>;
  isLoading?: boolean;
  errorMessage?: string | null;
};

const AppointmentMarkNoShowDialog: FC<AppointmentMarkNoShowDialogProps> = ({
  isOpen,
  handleClose,
  handleSubmit,
  isLoading,
  errorMessage,
}) => {
  const { translations } = useTranslations();

  const actionButtons = useMemo<StatusDialogProps["actionButtons"]>(() => {
    return [
      {
        text: translations.btnCancel,
        key: "cancel",
        onClick: handleClose,
        disabled: isLoading,
      },
      {
        text: translations.btnSubmit,
        key: "submit",
        onClick: handleSubmit,
        color: "error",
        disabled: isLoading || !!errorMessage,
      },
    ];
  }, [
    errorMessage,
    handleClose,
    handleSubmit,
    isLoading,
    translations.btnCancel,
    translations.btnSubmit,
  ]);

  return (
    <StatusDialog
      open={isOpen}
      title={translations.title}
      isLoading={isLoading}
      errorMessage={errorMessage}
      actionButtons={actionButtons}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          maxWidth: 500,
        },
      }}
    >
      <Typography>{translations.description}</Typography>
      <Typography mt={4}>{translations.warning}</Typography>
    </StatusDialog>
  );
};

export default AppointmentMarkNoShowDialog;
